import React, {FC} from "react"

import Markdown from "@irati/ui/src/Markdown"

import {Hr} from "@irati/ui/src/Layout"
import {ImportantInfoUl, ImportantInfoLi} from "./styled"

interface Props {
  data: string[]
}

const ImportantInfo: FC<Props> = ({data = []}) => {
  return (
    <>
      <Hr />
      <ImportantInfoUl>
        {data.map((e, i) => (
          <ImportantInfoLi key={i}>
            <Markdown source={e} />
          </ImportantInfoLi>
        ))}
      </ImportantInfoUl>
    </>
  )
}

export default ImportantInfo
